import { CoreUtils } from "@ms/1ds-core-js";
/**
* This class defines a "batch" events related to a specific iKey, it is used by the PostChannel and HttpManager
* to collect and transfer ownership of events without duplicating them in-memory. This reduces the previous
* array duplication and shared ownership issues that occurred due to race conditions caused by the async nature
* of sending requests.
*/
var EventBatch = /** @class */ (function () {
    /**
     * Private constructor so that caller is forced to use the static create method.
     * @param iKey - The iKey to associate with the events (not validated)
     * @param addEvents - The optional collection of events to assign to this batch - defaults to an empty array.
     */
    function EventBatch(iKey, addEvents) {
        var events = addEvents ? [].concat(addEvents) : [];
        var isNullOrUndefined = CoreUtils.isNullOrUndefined;
        var _self = this;
        _self.iKey = function () {
            return iKey;
        };
        _self.count = function () {
            return events.length;
        };
        _self.events = function () {
            return events;
        };
        _self.addEvents = function (theEvents, append) {
            if (append === void 0) { append = true; }
            if (theEvents && theEvents.length > 0) {
                if (append) {
                    events = events.concat(theEvents);
                }
                else {
                    events = theEvents.concat(events);
                }
                return theEvents.length;
            }
            return 0;
        };
        _self.split = function (fromEvent, numEvents) {
            // Create a new batch with the same iKey
            var newBatch = new EventBatch(iKey);
            if (fromEvent < events.length) {
                var cnt = events.length - fromEvent;
                if (!isNullOrUndefined(numEvents)) {
                    cnt = numEvents < cnt ? numEvents : cnt;
                }
                newBatch.addEvents(events.splice(fromEvent, cnt), true);
            }
            return newBatch;
        };
    }
    /**
     * Creates a new Event Batch object
     * @param iKey The iKey associated with this batch of events
     */
    EventBatch.create = function (iKey, theEvents) {
        return new EventBatch(iKey, theEvents);
    };
    return EventBatch;
}());
export { EventBatch };
//# sourceMappingURL=EventBatch.js.map